import React, { useEffect, useRef, useState } from "react";
import { SnapshotRenderer } from "oc-threejs/SnapshotRenderer";
import { Box3, Group } from "three";
import { quatEuler, v3 } from "oc-threejs/short3";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";

export function RenderImage({ jaco }: { jaco: Jaco }) {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const imageRef = useRef<HTMLDivElement>(null);
  const [backgroundImage, setBackgroundImage] = useState<HTMLImageElement | string | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (imageRef.current && !imageRef.current.contains(event.target as Node)) {
        setIsHovered(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Leerer Abhängigkeitsarray, damit der Effekt nur einmal ausgeführt wird

  useEffect(() => {
    async function loadImage() {
      if (imageRef.current) {
        const image = await renderJaco(imageRef.current, jaco);
        setBackgroundImage(image);
      }
    }
    loadImage();
  }, [jaco.toJSON()]);

  return (
    <div
      className={`Preview ${isHovered ? "zoomed" : ""}`}
      title="preview image"
      ref={imageRef}
      onClick={() => setIsHovered(true)}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {isHovered && (
        <div
          className="ZoomedImage"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />
      )}
    </div>
  );
}

async function renderJaco(div: HTMLDivElement, jaco: Jaco) {
  const jaco3d = jaco.jaco3d;
  if (jaco3d == null) {
    return null;
  }

  const renderer = new SnapshotRenderer();
  renderer.camera.up.copy(v3(0, 1, 0));

  jaco3d.quaternion.copy(quatEuler(0, 0, 0));
  const size = new Box3().setFromObject(jaco3d).getSize(v3());
  jaco3d.position.x = size.x * -0.5;
  jaco3d.position.y = 0.2;
  // Scenes.bring({
  //     what: [element3d, middleBottom],
  //     to: [v3(0, 0.1, 0)],
  //     translate: true,
  // });

  const group = new Group();
  group.name = "RenderImage";
  group.add(jaco3d);

  renderer.scene.add(group);
  const py = 1;
  renderer.camera.position.set(0, py, 2.5);
  renderer.camera.lookAt(v3(0, py, 0));

  // Debugs.checkVisibility(group, renderer.camera, renderer.scene, renderer.renderer);

  const image = renderer.getAsBackgroundImage(document.querySelector(".stage2d"));
  renderer.scene.remove(group);

  return image;
}
